import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";
import CreateCompanyComponent from "../../../components/Company/CreateCompany";
import { EzToast, TOAST_SEVERITY } from "../../../common/EzToast";
import { APP_URLS } from "../../../constants/urlConstants";
import { setIsformDirty } from "../../../Redux/Actions/common/form";
import {
  initCreateCompanyScreen,
  createCompany,
  
} from "../../../Redux/Actions/company";
import { fetchCountries } from "../../../Redux/Actions/country";
import { fetchProvincesByCountry } from "../../../Redux/Actions/province";
import { fetchCitysByProvince } from "../../../Redux/Actions/city";
const CreateCompany = (props) => {
  console.log("checkprops on screen ", props);
  const {
    history,
    createCompany,
    isLoading,
    isCreateCompanySuccess,
    isCreateCompnayError,
    isEdit,
    formFieldValueMap,
    shouldBlockNavigation,
    fetchCitysByProvince,
    fetchProvincesByCountry,
    fetchCountries,
    countries,
    provinces,
    citys,
  } = props;

  const { id } = props.match.params;
  const navigateToCompanySummaryScreen = () => {
    history.push(APP_URLS.CUSTOMER.HOME);
  };
  const [countryId, setCountryId] = useState(0);
  const [provinceId, setProvinceId] = useState(0);
  const [cityId, setCityId] = useState(0);

  const handleCountryChange = (selectedCountry) => {
    setCountryId(selectedCountry);
    let payload = { countryId: selectedCountry };
    fetchProvincesByCountry(payload);
  };

  const handleProvinceChange = (selectedProvince) => {
    setProvinceId(selectedProvince);
    let payload = { countryId: countryId, provinceId: selectedProvince };
    fetchCitysByProvince(payload);
  };

  const handleCityChange = (selectedCity) => {
    setCityId(selectedCity);
    let payload = {
      countryId: countryId,
      provinceId: provinceId,
      cityId: cityId,
    };
    // if need get by id city then call
  };
  const createCompanyProps = {
    createCompany,
    isLoading,
    isEdit,
    formFieldValueMap,
    shouldBlockNavigation,
    navigateToCompanySummaryScreen,
    isCreateCompnayError,
    isCreateCompanySuccess,
    countries,
    provinces,
    citys,
    onCountryChange: handleCountryChange,
    onProvinceChange: handleProvinceChange,
    onCityChange: handleCityChange,
  };
  useEffect(() => {
    fetchCountries();
  }, []);


  const getToastProps = () => {
    if (isCreateCompanySuccess) {
      const toastTitle = isEdit
        ? "Company Updated Successfully"
        : "Company Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isCreateCompnayError 
    ) {
      let toastTitle = "Error while Creating Company";
      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };
  return (
    <>
    {isLoading && renderProgressBar()}
    <EzToast {...getToastProps()} />
    <CreateCompanyComponent {...createCompanyProps} />;
  </>
  )
};


const mapStateToProps = (state, ownProps) => {
  console.log("mapState", state);
  return {
    isLoading: selectFromCompanyReducer(state, "isLoading"),
    isCreateCompanySuccess: selectFromCompanyReducer(
      state,
      "isCreateCompanySuccess"
    ),
    isCreateCompnayError: selectFromCompanyReducer(
      state,
      "isCreateCompnayError"
    ),
    countries: state?.countryReducer?.countries ?? [],
    provinces: state?.provinceReducer?.provinces ?? [],
    citys: state?.cityReducer?.citys ?? [],
    formFieldValueMap: selectFromCompanyReducer(state, "formFieldValueMap"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateCompanyScreen: () =>
      dispatch(initCreateCompanyScreen()),
      fetchProvincesByCountry: (payload) =>
      dispatch(fetchProvincesByCountry(payload)),
    fetchCountries: () => dispatch(fetchCountries()),
    fetchCitysByProvince: (payload) => dispatch(fetchCitysByProvince(payload)),
    createCompany: (payload) => dispatch(createCompany(payload)),
    shouldBlockNavigation: (isFormDirty) =>
      dispatch(setIsformDirty(isFormDirty)),
  };
};

const selectFromCompanyReducer = (state, path) => {
  return selectCompanyReducer(state)[path];
};

const selectCompanyReducer = ({ companyReducer }) => {
  return companyReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCompany);
